import * as React from "react";
import type { IconName } from "../../icons";
import { icons } from "../../icons";
import styles from "./Button.css";

const sizeMapIcon = {
  small: "1rem",
  medium: "1.5rem",
  large: "1.5rem",
} as const;

type Size = keyof typeof sizeMapIcon;
type Color = "neutral" | "accent" | "success" | "error";
type Variant = "primary" | "secondary";

interface ButtonProps {
  title: string;
  size?: Size;
  color?: Color;
  variant?: Variant;
  iconLeft?: IconName;
  iconRight?: IconName;
  disabled?: boolean;
  type?: "button" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const Button = ({
  title,
  size = "medium",
  color = "neutral",
  variant = "primary",
  type = "button",
  iconLeft,
  iconRight,
  disabled,
  onClick,
}: ButtonProps) => {
  const IconLeft = iconLeft ? icons[iconLeft] : null;
  const IconRight = iconRight ? icons[iconRight] : null;

  return (
    <button
      className={styles.button({ size, color, variant })}
      type={type}
      disabled={disabled}
      onClick={onClick}
    >
      {IconLeft && <IconLeft size={sizeMapIcon[size]} />}
      {title}
      {IconRight && <IconRight size={sizeMapIcon[size]} />}
    </button>
  );
};

export default Button;
